<!-- 汇率查询 -->
<template>
  <div class="interOrderHN">
    <order-search
      ref="orderSearch"
      :searchColumns="searchColumns"
      :searchForm="searchForm"
      :columnList="columnList"
      :reserve="true"
      :api="api"
      :rules="rules"
      type="HN"
      :showFooter="1 == 1"
      :footerTotalCols="footerTotalCols"
    ></order-search>
  </div>
</template>

<script>
  import { baseRules } from '../components/rules.js'; // 校验规则
  // import API from '@/api/capitalCenter/moneyDraw';
  import orderSearch from '../components/orderSearch';
  // import InputNumber from '@/components/form-item/input-number';
  // import IG_API from '@/api/masterData/intersetGroup.js';
  export default {
    name: 'interOrderHN',
    components: {
      orderSearch,
      // InputNumber,
    },
    computed: {
      searchColumns() {
        return [
          {
            name: this.$t('interOrderPool.column.orderNo'),
            prop: 'orderNo',
            type: 'input',
            clearable: true,
          },
          {
            name: this.$t('interOrderPool.search.orderDateStart'),
            prop: 'orderDateStart',
            type: 'startDaterangePicker',
          },
          {
            name: this.$t('interOrderPool.search.orderDateEnd'),
            prop: 'orderDateEnd',
            type: 'endDaterangePicker',
          },
          /* { // 部门组
          prop: "interestGroupCodes",
          name: "部门组",
          type: "ajaxSelect",
          apiUrl: IG_API.INTERSET_GROUP_LIST,
          apiData: {},
          clearable: true,
          filterable: true,
          valueKey: "interestGroupCode",
          labelKey: "interestGroupName",
          method: "post",
          multiple: true
        }, */
        ];
      },
      //基础数据表单配置
      columnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            field: 'orderNo',
            title: this.$t('interOrderPool.column.orderNo'),
          },
          /*  {
          field: "orderInterestGroupName",
          title: "部门组",
        }, */
          {
            field: 'eventName',
            title: this.$t('interOrderPool.column.event'),
          },
          {
            field: 'orderDate',
            title: this.$t('interOrderPool.column.orderDate'),
          },
          {
            field: 'customerName',
            title: '客户',
          },
          {
            field: 'paymentAmount',
            title: this.$t('interOrderPool.column.paymentAmount'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row.paymentAmount}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row.paymentAmount}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.chooseTable(val, row, 'paymentAmount')}
                  ></input-number>,
                ];
              },
            },
          },
          {
            field: 'receiptAmount',
            title: this.$t('interOrderPool.column.receiptAmount'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row.receiptAmount}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row.receiptAmount}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.chooseTable(val, row, 'receiptAmount')}
                  ></input-number>,
                ];
              },
            },
          },
          {
            field: 'interestStatus',
            title: '计息状态',
            formatter: this.formatInterestStatus,
          },
          {
            field: 'orderType',
            title: '订单类型',
            formatter: this.formatOrderType,
          },
        ];
      },
    },
    data() {
      return {
        footerTotalCols: { price: ['paymentAmount', 'receiptAmount'] }, //底部合计列-字段名，数字类型（金额amount，数量quantity等）判断小数点
        api: {
          query: 'QUERY_INTRORDERHN_PAGE',
          cal: 'CAL_INTRORDERHN',
        },
        rules: baseRules,
        searchForm: {
          orderNo: null,
          orderDateStart: null,
          orderDateEnd: null,
          interestGroupCodes: null,
        },
      };
    },
    mounted() {
      if (Object.keys(this.$route.query).length > 0) {
        let query = this.$route.query;
        this.searchForm.orderDateStart = this.searchForm.orderDateEnd = query.interestDate;
        this.$refs.orderSearch.searchBtnClick();
      }
    },
    methods: {
      chooseTable(val, row, prop) {
        row[prop] = val;
      },
      formatInterestStatus({ cellValue }) {
        return cellValue
          ? this.$refs.orderSearch.interestStatusOption.find((item) => cellValue == item.value)
              .label
          : null;
      },
      formatOrderType({ cellValue }) {
        return this.$baseRequest.getDictValueByType('hn_order_businessType', cellValue);
      },
    },
  };
</script>
